import { useEffect, useState } from "react";
import TodosProvider from "../context";
import App from "../app/App";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import UseAuthConfig from "../hooks/useAuthConfig";
import Loader from "../components/atoms/Loader/Loader";

const MsalHandle = () => {
  const { msalConfig, protectedResources } = UseAuthConfig();
  const [msalInstance] = useState(
    () => new PublicClientApplication(msalConfig)
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const fetchAccessToken = async (account, role) => {
      try {
        const loginRequest = {
          scopes: [
            ...protectedResources.apiTodoList.scopes.read,
            ...protectedResources.apiTodoList.scopes.write,
          ],
          account,
        };

        const tokenResponse = await msalInstance.acquireTokenSilent(
          loginRequest
        );
        if (tokenResponse?.accessToken) {
          localStorage.setItem("AccessToken", tokenResponse.accessToken);
          window.location.replace("/");
        }
      } catch (error) {
        console.error("Access Token Fetch Failed:", error);
        setReady(true); // Let the app continue even if token fetch fails
      }
    };

    const initMSAL = async () => {
      try {
        const response = await msalInstance.handleRedirectPromise();

        if (response?.account) {
          msalInstance.setActiveAccount(response.account);
          const role = response.idTokenClaims?.extension_ilpr;
          await fetchAccessToken(response.account, role);
          return; // Exit to prevent duplicate setReady
        }

        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
          msalInstance.setActiveAccount(accounts[0]);
        }

        msalInstance.addEventCallback((event) => {
          if (
            [
              EventType.LOGIN_SUCCESS,
              EventType.ACQUIRE_TOKEN_SUCCESS,
              EventType.SSO_SILENT_SUCCESS,
            ].includes(event.eventType) &&
            event.payload?.account
          ) {
            msalInstance.setActiveAccount(event.payload.account);
          }
        });

        // No login response, but session exists – proceed
        setReady(true);
      } catch (error) {
        console.error("MSAL redirect error:", error);
        setReady(true); // Allow app to render with fallback
      }
    };

    initMSAL();
  }, [msalInstance, protectedResources]);

  if (!ready) return <Loader />;

  return (
    <TodosProvider>
      <App instance={msalInstance} />
    </TodosProvider>
  );
};

export default MsalHandle;
